import Banner from "../components/banner/Banner";
import Footer from "../components/footer/Footer";
import Navbar from "../components/navbar/Navbar";
import RegisterPage from "../components/register/RegisterComp";
import "../components/cart/Cart.css"
import Reg from "../components/Reg";
import { useEffect } from "react";

const Register=()=>{
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return(
        <div className="bg-imagea">
<Navbar/>
 <Banner title="SignUp"/>
<RegisterPage/> 
{/* <Reg/> */}
<Footer/>
</div>
    )
}
export default Register;